import * as React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import OAuth2Service from '../../../services/OAuth2'

import * as style from './style.module.css'

export interface LoginProps {
  activatedRoute: string
}

export class LoginComponent extends React.Component<LoginProps, any> {

  OAuth2Uri: string

  componentDidMount() {
    window.location.assign(new OAuth2Service().getAuthorizeUri(this.props.activatedRoute))
  }

  render() {
    return (<div className={style.spinner}><CircularProgress size="20%" /></div>)
  }
}
